import moment from "moment-timezone";

export default function getIntervalsInRange(
  period: AvailableTimePeriod,
  startDateValue: number,
  endDateValue: number,
  timezone: TimeZone,
): ScheduleInterval[] {
  // could not be in the range
  if (+new Date(period.start_date) > endDateValue) {
    return [];
  }

  if (period.end_date && +new Date(period.end_date) < startDateValue) {
    return [];
  }

  const periodStartDateValue = +new Date(period.start_date);
  const periodEndDateValue = !period.end_date
    ? Infinity
    : +new Date(period.end_date);

  // get the intervals on preferred timezone same day
  const intervals: ScheduleInterval[] = period.available_intervals.reduce(
    (prev, curr) => [...prev, ...splitInterval(curr, timezone)],
    [] as ScheduleInterval[],
  );
  const res: ScheduleInterval[] = [];

  while (intervals.length) {
    const curr = intervals.pop() as ScheduleInterval;
    if (
      // in the period range
      +new Date(curr.start_time) >= periodStartDateValue &&
      +new Date(curr.start_time) <= periodEndDateValue &&
      // in the calendar range
      +new Date(curr.start_time) >= startDateValue &&
      +new Date(curr.start_time) <= endDateValue
    ) {
      res.push(curr);
      intervals.push(getNextWeekInterval(curr, timezone));
    } else if (+new Date(curr.start_time) < startDateValue) {
      intervals.push(getNextWeekInterval(curr, timezone));
    }
  }

  return res;
}

function splitInterval(interval: ScheduleInterval, timezone: TimeZone) {
  const startDayIndex = moment(interval.start_time).tz(timezone).weekday();
  const endDayIndex = moment(interval.end_time).tz(timezone).weekday();
  if (startDayIndex === endDayIndex) {
    return [interval];
  }
  const splitTime = moment(interval.end_time).tz(timezone).startOf("day");

  const splitTimeValue = splitTime.valueOf();
  const splitTimeString = splitTime.toISOString();

  // sanity check
  const res: ScheduleInterval[] = [];

  if (splitTimeValue !== +new Date(interval.start_time)) {
    res.push({
      start_time: interval.start_time,
      end_time: splitTimeString,
    });
  }

  if (splitTimeValue !== +new Date(interval.end_time)) {
    res.push({
      start_time: splitTimeString,
      end_time: interval.end_time,
    });
  }

  return res;
}

function getNextWeekInterval(
  interval: ScheduleInterval,
  timezone: TimeZone,
): ScheduleInterval {
  const nextStartDate = moment(interval.start_time).tz(timezone).add(7, "d");
  const nextEndDate = moment(interval.end_time).tz(timezone).add(7, "d");

  return {
    start_time: nextStartDate.toISOString(),
    end_time: nextEndDate.toISOString(),
  };
}
